import React from "react";
import { motion } from "framer-motion";
import ProductsSection from "../components/Products/ProductsSection";
import ProductCards from "../components/Products/ProductCards";
import ProductsPageSlider from "../components/Products/ProductsPageSlider";
import Footer from "../components/Footer";
import Topbar from "../components/Topbar";
import Navbar from "../components/Navbar";
import Banner from "../components/ProductsBanner";
import Partners from "../components/Partners_logo";

function Offers() {
  return (
    <>
      <Topbar />
      <Navbar />
      <Banner />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ staggerChildren: 0.25 }}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <motion.div
          variants={{
            hidden: { opacity: 0, y: 40 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <ProductsSection />
        </motion.div>
        <motion.div
          variants={{
            hidden: { opacity: 0, y: 40 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <ProductCards />
        </motion.div>
        <motion.div
          variants={{
            hidden: { opacity: 0, y: 40 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <ProductsPageSlider />
        </motion.div>
        <motion.div
          variants={{
            hidden: { opacity: 0, y: 40 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <Partners />
        </motion.div>
      </motion.div>

      <Footer />
    </>
  );
}

export default Offers;
